import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space['space-050']};
  width: 100%;
  padding: ${space['space-400']};
  box-sizing: border-box;
  text-align: left;
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${size.radius['radius-md']};
  background: ${semantic.bg.canvas};
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &[data-selected='true'] {
    background: ${semantic.bg.brand};
    border-color: ${semantic.bg.brand};
  }

  &:disabled {
    background: ${semantic.bg.surfaceSubtle};
    border-color: ${semantic.border.subtle};
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }

  &:hover:not(:disabled):not([data-selected='true']) {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const Time = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  white-space: nowrap;

  [data-selected='true'] & {
    color: ${semantic.text.inverse};
  }

  :disabled & {
    color: ${semantic.text.tertiary};
  }
`;

export const Detail = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.secondary};
  white-space: nowrap;

  [data-selected='true'] & {
    color: ${semantic.text.inverse};
  }

  :disabled & {
    color: ${semantic.text.tertiary};
  }
`;
